import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../../components/ErrorMessage';
import Metadata from '../../../components/Metadata';
import RecommenderForm from '../../../components/Recommenders/RecommenderForm';
import Spinner from '../../../components/Spinner';
import { DEFAULT_CHROME_CSS_STYLES } from '../../../constants/bannerChrome';
import { Page } from '../../../constants/pageTitles';
import recommenderRules from '../../../constants/recommenderRules';
import useFetch from '../../../helpers/useFetch';

const pageTitle = `${Page['recommenders']}`;
const RecommendersNewPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();

  const { accountId, domainId, pageId } = useParams();
  const [segments, setSegments] = useState();
  const [page, setPage] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch((error) => {
        setError(error);
        setSegments([]);
      });

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages/${pageId}`)
      .then(({ page }) => {
        setPage(page);
      })
      .catch((error) => {
        setError(error);
      });
  }, [fetch, accountId, domainId, pageId]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (segments === undefined || page === undefined) {
    return (
      <>
        <Spinner />
      </>
    );
  }

  const recommender = {
    title: 'New product block',
    name: 'Unique name',
    pageId,
    algorithm: 'viewedThisViewedThat',
    segmentId: segments[0]?.id,
    minCount: 0,
    count: 5,
    mode: 'highlight',
    displayStrategy: 'beforeend',
    rules: recommenderRules,
    tags: [],
    urlCondition: 'any',
    segmentRelationship: 'and',
    displayType: 'static',
    inverseSegmentSelection: false,
    advancedStyling: false,
    randomize: false,
    cssStyles: { ...DEFAULT_CHROME_CSS_STYLES },
    storeLocales: [],
  };

  return (
    <>
      <Metadata title={`${pageTitle} | New`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor
          href={`#/accounts/${accountId}/domains/${domainId}/pages?type=recommenders&page=${recommender?.pageId || ''}`}
        >
          {page.name} Product Blocks
        </Anchor>
        <Text>New</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <RecommenderForm
            scope="web"
            recommender={recommender}
            allowSegmentSelection={true}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/pages?type=recommenders`)}
          />
        </Grid.Col>
        <Grid.Col span={3}></Grid.Col>
      </Grid>
    </>
  );
};

export default RecommendersNewPage;
